import { render, staticRenderFns } from "./PageSignUpRegister.vue?vue&type=template&id=6a8f9026"
import script from "./PageSignUpRegister.vue?vue&type=script&lang=js"
export * from "./PageSignUpRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports